import React, { useState, useEffect } from 'react';

// Imports locaux
import { Navigation, Footer } from './components';
import { HomePage, AboutPage, ProjectsPage, SkillsPage, ContactPage } from './pages';
import { globalStyles, theme } from './styles';
import { useMobile, useMounted } from './hooks';

// ============================================
// 🚀 COMPOSANT PRINCIPAL
// ============================================

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const isMobile = useMobile(768);
  const isMounted = useMounted();

  // Fermer le menu mobile quand on change de page
  useEffect(() => {
    setIsMenuOpen(false);
  }, [currentPage]);

  // Scroll en haut quand on change de page
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const renderPage = () => {
    const pageProps = { isMobile };
    
    switch (currentPage) {
      case 'home':
        return <HomePage {...pageProps} />;
      case 'about':
        return <AboutPage {...pageProps} />;
      case 'projects':
        return <ProjectsPage {...pageProps} />;
      case 'skills':
        return <SkillsPage {...pageProps} />;
      case 'contact':
        return <ContactPage {...pageProps} />;
      default:
        return <HomePage {...pageProps} />;
    }
  };

  return (
    <div style={styles.app}>
      {/* Injection des styles globaux */}
      <style>{globalStyles}</style>
      
      {/* Navigation */}
      <Navigation
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        isMobile={isMobile}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />

      {/* Contenu principal */}
      <main style={{
        ...styles.main,
        opacity: isMounted ? 1 : 0,
        transform: isMounted ? 'translateY(0)' : 'translateY(20px)',
      }}>
        {renderPage()}
      </main>

      {/* Footer */}
      <Footer isMobile={isMobile} />
    </div>
  );
}

// ============================================
// 💅 STYLES
// ============================================

const styles = {
  app: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: `linear-gradient(135deg, ${theme.colors.background} 0%, ${theme.colors.backgroundAlt} 50%, ${theme.colors.background} 100%)`,
    overflowX: 'hidden',
  },
  main: {
    flex: 1,
    transition: theme.transition.slow,
  },
};
